export const CDN_URL = 'https://ufa-cdn.baibars.club/ufa-app-portal';
export const CURRENCY_SYMBOL = '$';
export const DEFAULT_ERROR_TEXT = 'A Problem Occurred';
